'use client';

import { ImgHTMLAttributes, memo } from 'react';

import { Loader } from 'components/common/index';
import { STypography } from 'components/ui';

import { useImage } from 'hooks';

type ImageProps = ImgHTMLAttributes<HTMLImageElement> & {
  src?: string;
  alt?: string;
};

// todo - why is this loading the image twice? does it get cached?
// todo - this need replacement with next/image
const Image = memo<ImageProps>(({ src, alt = '', ...props }) => {
  const { isLoaded: isLoadedImage, isError: isErrorImage } = useImage(src);

  return isErrorImage ? (
    <STypography variant="body2">Failed to load Image</STypography>
  ) : !isLoadedImage ? (
    <Loader linear />
  ) : (
    <img src={src} alt={alt} {...props} />
  );
});

Image.displayName = 'Image';

export default Image;
